import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { EmailAlias } from '.';
import { Button } from '@progress/kendo-react-buttons';
import { pencilIcon, xIcon } from '@progress/kendo-svg-icons';

export default function MyCommandCell(
  enterEdit: (dataItem: EmailAlias) => void,
  remove: (dataItem: EmailAlias) => void,
  save: (dataItem: EmailAlias) => void,
  cancel: (dataItem: EmailAlias) => void,
  editField: string
) {
    return class extends React.Component<GridCustomCellProps> {
        render() {
            return !this.props.dataItem[editField]
                ? (
                    <td {...this.props.tdProps} className={[this.props.tdProps?.className, "k-command-cell"].filter(Boolean).join(" ")}>
                        <Button
                            themeColor="primary"
                            className="k-grid-edit-command"
                            svgIcon={pencilIcon}
                            onClick={(e) => enterEdit(this.props.dataItem)}
                        />
                        <Button
                            className="k-grid-remove-command"
                            svgIcon={xIcon}
                            themeColor="error"
                            onClick={(e) => window.confirm('Confirm deleting: ' + this.props.dataItem.CustomerNumber) && remove(this.props.dataItem)}
                        />
                    </td>
                )
                : (
                    <td {...this.props.tdProps} className={[this.props.tdProps?.className, "k-command-cell"].filter(Boolean).join(" ")}>
                        <Button
                            className="k-grid-save-command"
                            onClick={(e) => save(this.props.dataItem)}>
                            {this.props.dataItem.CustomerEmailAliasID
                                ? 'Update'
                                : 'Add'}
                        </Button>
                        <Button
                            className="k-grid-cancel-command"
                            onClick={(e) => cancel(this.props.dataItem)}>{this.props.dataItem.CustomerEmailAliasID
                                ? 'Cancel'
                                : 'Discard'}
                        </Button>
                    </td>
                );
        }
    }
};
